import type { MutationSettings } from '@customTypes/index';
import { useMutation } from '@tanstack/react-query';

import type { AcceptWorkRequestParams } from '@/features/work/api/accept-work-request/request';
import { acceptWorkRequest } from '@/features/work/api/accept-work-request/request';

export const useAcceptWorkRequestMutation = (
  settings?: MutationSettings<AcceptWorkRequestParams, typeof acceptWorkRequest>
) =>
  useMutation({
    mutationKey: ['AcceptWorkRequest'],
    mutationFn: ({ params, config }) =>
      acceptWorkRequest({
        params,
        config
      }),
    ...settings?.options
  });
